/* eslint-disable no-unused-vars */
/* eslint-disable no-unsafe-optional-chaining */
import { InputText } from "primereact/inputtext";
import {
  FunctionComponent,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { Checkbox } from "primereact/checkbox";
import CustomerService from "services/customer-service";
import { handlingUrlParams } from "Utils/AppUtils";
import Select from "react-select";
import RolesService from "services/roles-service";
import Loader from "common/Loader";
import { Button } from "primereact/button";
import { setToaster } from "common/toastStore";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IAddUser, Idropdpwn } from "types/customers.type";
import TokenService from "services/TokenService";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { confirmDialog } from "primereact/confirmdialog";
import UserService from "services/users-service";

interface AddUsersProps {}

const AddUsers: FunctionComponent<AddUsersProps> = () => {
  let navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [appsList, setAppsList] = useState<string[]>([]);
  const [rolesList, setRolesList] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  //   const [validateApps, setValidateApps] = useState<boolean>(false);
  const [selectedCustomer, setSelectedCustomer] = useState<Idropdpwn>();
  const [selectedApps, setSelectedApps] = useState<Idropdpwn>();
  const [selectedRole, setSelectedRole] = useState<Idropdpwn>();
  const [responseData, setResponseData] = useState<any[]>([]);
  const getUserType = TokenService.getLoggedInUserType();
  const getUserDataFromStorage = TokenService.geUserMenu();

  const [inputValue, setInputValue] = useState<IAddUser>({
    email: "",
    firstName: "",
    lastName: "",
    isSuperAdmin: true,
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setInputValue({
      ...value,
      [name]: value,
    });
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
  });

  const formOptions = {
    resolver: yupResolver(validationSchema),
    mode: "all",
  };
  const { register, handleSubmit, formState } = useForm<IAddUser>(
    formOptions as object
  );
  const { errors } = formState;

  function onSubmit(data: IAddUser) {
    if (checked) {
      console.log("good to go...");
    } else {
      if (responseData.length === 0) {
        setToaster({
          severity: "error",
          summary: "Error Message",
          detail: "Please Add atleast one Application",
        });
        return false;
      }
    }
    const payload = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      isSuperAdmin: getUserType ? checked : false,
      applications: responseData,
    };
    setLoading(true);
    UserService.addUsers(payload)
      .then((_response: any) => {
        setLoading(false);
        setToaster({
          severity: "success",
          summary: "Success ",
          detail: `User Added successfully!`,
        });
        navigate("../users");
      })
      .catch((e: any) => {
        setLoading(false);
        setToaster({
          severity: "error",
          summary: "Error Message",
          detail: `${e?.response?.data}`,
        });
      });
  }

  const fetchData = async () => {
    let customersList: any = [];
    let appsList: any = [];
    let mainAppsListArray: any = [];
    let rolesList: any = [];

    setLoading(true);
    let customers = await CustomerService.getCustomers(
      handlingUrlParams({
        PageNumber: 1,
        PageSize: 10000,
      })
    );
    let roles = await RolesService.getRoles(
      handlingUrlParams({
        PageNumber: 1,
        PageSize: 10000,
      })
    );
    if (getUserType) {
      customers.data.forEach((element: { name: string; id: any }) => {
        customersList.push({
          label: element.name,
          value: element.id,
        });
      });

      customers.data?.forEach((element: { customerApplications: any }) => {
        mainAppsListArray.push(...element?.customerApplications);
      });

      mainAppsListArray.forEach((element: any) => {
        appsList.push({
          label: element.application.name,
          value: element.application.id,
        });
      });
    } else {
      getUserDataFromStorage.forEach((element: { name: string; id: any }) => {
        customersList.push({
          label: element.name,
          value: element.id,
        });
      });

      customers.data?.forEach((element: { customerApplications: any }) => {
        mainAppsListArray.push(...element?.customerApplications);
      });

      getUserDataFromStorage[0].applications.forEach(
        (element: { name: any; customerApplicationId: any }) => {
          appsList.push({
            label: element?.name,
            value: element?.customerApplicationId,
          });
        }
      );
    }
    setCustomerList(customersList);
    console.log("appsList", appsList);
    setAppsList(appsList);

    roles.data.forEach((element: any) => {
      rolesList.push({
        label: element.name,
        value: element.id,
      });
    });
    setRolesList(rolesList);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const addCustomerToTable = () => {
    if (selectedCustomer?.label === undefined) {
      setToaster({
        severity: "error",
        summary: "Error Message",
        detail: "Please select customer",
      });
    } else if (selectedApps?.label === undefined) {
      setToaster({
        severity: "error",
        summary: "Error Message",
        detail: "Please select customer Apps",
      });
    } else if (selectedRole?.label === undefined) {
      setToaster({
        severity: "error",
        summary: "Error Message",
        detail: "Please select Role",
      });
    } else {
      const item = {
        customer: selectedCustomer?.label,
        customerId: selectedCustomer?.value,
        app: selectedApps?.label,
        customerApplicationId: selectedApps?.value,
        role: selectedRole?.label,
        roleId: selectedRole?.value,
      };

      var valueArr = responseData.map(function (obj) {
        if (
          obj.role !== item.role ||
          obj.app !== item.app ||
          obj.customer !== item.customer
        ) {
          return obj;
        } else {
          return;
        }
      });

      var isDuplicate = valueArr.some(function (compareObj, idx) {
        if (valueArr[idx] === undefined) {
          return true;
        } else {
          return valueArr.indexOf(compareObj) != idx;
        }
      });
      if (isDuplicate) {
        setToaster({
          severity: "error",
          summary: "Error Message",
          detail: "Application already exist, please add another",
        });
        return false;
      } else {
        setResponseData([...responseData, item]);
      }
    }
  };

  const customerHandleChange = (e: any) => {
    setSelectedCustomer(e);
  };

  const appsHandleChange = (e: any) => {
    setSelectedApps(e);
  };

  const appsRoleHandle = (e: any) => {
    setSelectedRole(e);
  };

  const backToUsers = () => {
    navigate("/users");
  };

  const isConfirming = useRef(false);

  const removeAppItem = useCallback(
    (idx: any) => {
      // ... your existing remove logic
      const list = responseData.filter((item) => item !== idx);
      setResponseData(list);
    },
    [responseData]
  );

  // 2. Update deleteConfirm to check the ref
  const deleteConfirm = useCallback(
    (item: any, e?: any) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      // BLOCKER: If dialog is already opening/open, stop here.
      if (isConfirming.current) return;
      isConfirming.current = true;

      confirmDialog({
        message:
          "Are you sure you want to proceed to delete " + item?.app + "?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        accept: () => {
          removeAppItem(item);
          isConfirming.current = false; // Release lock
        },
        reject: () => {
          isConfirming.current = false; // Release lock
        },
        onHide: () => {
          isConfirming.current = false; // Release lock (Important for 'X' close)
        },
      });
    },
    [removeAppItem] // isConfirming is a ref, so it doesn't need to be in deps
  );

  const deleteApps = useCallback(
    (rowData: any) => {
      return (
        <Button
          onClick={(e) => deleteConfirm(rowData, e)}
          type="button"
          icon="pi pi-trash"
          className="p-button-outlined p-button-rounded p-button-danger"
          aria-label="Delete"
        />
      );
    },
    [deleteConfirm]
  );

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="py-4">
        <div className="grid grid-cols-4 gap-8">
          <div>
            <div className="p-float-label">
              <InputText
                id="email"
                {...register("email")}
                name="email"
                onChange={handleChange}
                className="w-full text-sm"
              />
              <label htmlFor="email">Enter email</label>
            </div>
            <div className="text-xs text-red-900">{errors.email?.message}</div>
          </div>
          <div>
            <div className="p-float-label">
              <InputText
                id="firstName"
                {...register("firstName")}
                name="firstName"
                onChange={handleChange}
                className="w-full text-sm"
              />
              <label htmlFor="firstName">Enter First Name</label>
            </div>
            <div className="text-xs text-red-900">
              {errors?.firstName?.message}
            </div>
          </div>
          <div>
            <div className="p-float-label">
              <InputText
                id="lastName"
                {...register("lastName")}
                name="lastName"
                onChange={handleChange}
                className="w-full text-sm"
              />
              <label htmlFor="lastName">Enter Last Name</label>
            </div>
            <div className="text-xs text-red-900">
              {errors?.lastName?.message}
            </div>
          </div>
          {getUserType ? (
            <div className="flex flex-row items-center">
              <div className="field-checkbox">
                <Checkbox
                  inputId="isSuperAdmin"
                  checked={checked}
                  onChange={(e) => {
                    setChecked(e.checked ?? false);
                  }}
                />
                <label htmlFor="isSuperAdmin" className="px-3">
                  is Super Admin
                </label>
              </div>
            </div>
          ) : null}
          <div>
            <Select
              options={customerList}
              placeholder="Select a Customer"
              defaultValue={customerList[0]}
              onChange={customerHandleChange}
              menuPortalTarget={document.body}
            />
          </div>
          <div>
            <Select
              options={appsList}
              placeholder="Select Application"
              defaultValue={appsList[0]}
              onChange={appsHandleChange}
              menuPortalTarget={document.body}
            />
          </div>
          <div>
            <Select
              options={rolesList}
              placeholder="Select Role"
              defaultValue={rolesList[0]}
              onChange={appsRoleHandle}
              menuPortalTarget={document.body}
            />
          </div>
          <div>
            <Button
              onClick={() => addCustomerToTable()}
              type="button"
              icon="pi pi-plus"
              label="Add"
              className="p-button-sm p-button-outlined p-button-success"
            />
          </div>
        </div>
        {responseData && responseData.length ? (
          <DataTable
            className="shadow-md my-6"
            scrollable
            scrollHeight="300px"
            value={responseData}
            stripedRows
            paginator={true}
            filterDisplay="menu"
            responsiveLayout="scroll"
            rows={10}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rowsPerPageOptions={[10, 20, 50]}
            emptyMessage="No Apps found."
            totalRecords={responseData.length}
          >
            <Column field="customer" header="Customer"></Column>
            <Column field="app" header="Application"></Column>
            <Column field="role" header="Role"></Column>
            <Column body={deleteApps} header="Action"></Column>
          </DataTable>
        ) : null}
        <div className="mt-8 flex flex-row-reverse items-center">
          <Button
            label="Save"
            type="submit"
            icon="pi pi-check"
            className="p-button-sm p-button-success p-button-outlined"
          />
          <div className="mx-2"></div>
          <Button
            onClick={backToUsers}
            label="Cancel"
            icon="pi pi-times"
            className="p-button-sm p-button-danger p-button-outlined"
          />
        </div>
      </form>
      {loading ? <Loader /> : null}
      {/* ConfirmDialog is provided globally in App.tsx; do not render a local instance here */}
    </>
  );
};

export default AddUsers;
